module.exports = __webpack_public_path__ + "assets/b508c0d9d15c3e5da39a8a8cb1da543f.mp4";